import React from "react";
import Seo from "components/Seo";
import CompanyLayout from "./companyLayout";
import Location from "../../../common/-pages/company/location";

const MorningLocation = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="오시는길" />
            <CompanyLayout>
                <Location />
            </CompanyLayout>
        </React.Fragment>
    );
};
export default MorningLocation;
